import { render, staticRenderFns } from "./EditSchool.vue?vue&type=template&id=4ec682aa&scoped=true&"
import script from "./EditSchool.vue?vue&type=script&lang=js&"
export * from "./EditSchool.vue?vue&type=script&lang=js&"
import style0 from "./EditSchool.vue?vue&type=style&index=0&id=4ec682aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec682aa",
  null
  
)

export default component.exports